export default {
  SYSTEM_ERROR: 'Ocurrió un error. Intente nuevamente.',
  UNEXPECTED_ERROR: 'Se produjo un error inesperado.',
  ACCESS_DENIED: 'Acceso denegado.',
}
